/* Article commerce navigation. Uses the existing consent/bot-gated Google tag.
   Records one article_hardware_view per hardware block when a card is half visible,
   article_hardware_click / article_quote_click on link clicks, and article_download once when
   Shopify has confirmed a checklist form post. Never blocks navigation. */
(function () {
  if (window.imdArticleCommerceBound) return;
  window.imdArticleCommerceBound = true;
  function payload(block, extra) {
    var data = {
      article: block.dataset.article,
      intent: block.dataset.intent,
      placement: block.dataset.placement,
      transport_type: 'beacon'
    };
    if (block.dataset.variant) data.variant = block.dataset.variant;
    for (var key in extra) data[key] = extra[key];
    return data;
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-imd-commerce-action]');
    if (!link) return;
    var block = link.closest('[data-imd-article-commerce]');
    if (!block) return;
    var action = link.dataset.imdCommerceAction;
    if (action !== 'hardware' && action !== 'quote' && action !== 'resource') return;
    if (typeof window.gtag !== 'function') return;
    try {
      var destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin) return;
      var eventName = action === 'quote' ? 'article_quote_click' : action === 'resource' ? 'article_resource_click' : 'article_hardware_click';
      window.gtag('event', eventName,
        payload(block, { link_path: destination.pathname }));
    } catch (error) { /* Analytics must never prevent navigation. */ }
  });
  function observeViews() {
    if (typeof document.querySelectorAll !== 'function' || typeof window.IntersectionObserver !== 'function') return;
    var links = document.querySelectorAll('[data-imd-article-commerce] a[data-imd-commerce-action], [data-imd-article-commerce] button[data-imd-commerce-action]');
    if (!links.length) return;
    var observer = new window.IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) continue;
        var block = entry.target.closest && entry.target.closest('[data-imd-article-commerce]');
        if (!block || block.dataset.imdViewed) { observer.unobserve(entry.target); continue; }
        block.dataset.imdViewed = '1';
        observer.unobserve(entry.target);
        if (typeof window.gtag !== 'function') continue;
        try { window.gtag('event', 'article_hardware_view', payload(block, {})); } catch (error) { /* ignore */ }
      }
    }, { threshold: 0.5 });
    for (var j = 0; j < links.length; j++) observer.observe(links[j]);
  }
  function recordDownload() {
    if (typeof document.querySelector !== 'function' || typeof window.gtag !== 'function') return;
    var block = document.querySelector('[data-imd-article-commerce][data-imd-download-posted]');
    if (!block || block.dataset.imdDownloadSent) return;
    block.dataset.imdDownloadSent = '1';
    try { window.gtag('event', 'article_download', payload(block, {})); } catch (error) { /* ignore */ }
  }
  try {
    if (document.readyState === 'loading' && typeof document.addEventListener === 'function') {
      document.addEventListener('DOMContentLoaded', function () { observeViews(); recordDownload(); });
    } else {
      observeViews();
      recordDownload();
    }
  } catch (error) { /* Analytics must never break the page. */ }
})();
